export enum LicenseStatus {
  unset = 'unset',
  violated = 'violated',
  expired = 'expired',
  valid = 'valid',
  nearViolated = 'nearViolated',
  overViolatedUnderGracePeriod = 'overViolatedUnderGracePeriod',
  overViolatedGracePeriodOver = 'overViolatedGracePeriodOver'
}
